import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import {
  Collapse,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Close, Menu } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { AvatarMenu } from "../../avatar-menu";
import useViewModel from "./ViewModel";
import { useNavigate } from "react-router-dom";
import {
  selectProfile,
  selectProfileRole,
} from "../../../store/profile/selector";
import { LoginContent } from "../../../shared/Components/login";
import { setProfile, setProfileRole } from "../../../store/profile/slice";
import { useSnackbar } from "notistack";
import isEqual from "lodash.isequal";

interface NavItem {
  label: string;
  href: string;
}
const NAV_ITEMS: Array<NavItem> = [
  {
    label: "Home",
    href: "#home",
  },
  {
    label: "About Us",
    href: "#about-us",
  },
  {
    label: "Services",
    href: "#services",
  },
  {
    label: "Contact",
    href: "#contact",
  },
];

export function Header() {
  const { data, method } = useViewModel();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [mobileBarOpen, setMobileBarOpen] = useState(false);

  const dispatch = useDispatch();
  const passportState = useSelector(selectProfile);
  const profileRole = useSelector(selectProfileRole);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (passportState) {
      method.onGetLatestProfile(passportState);
    }
  }, []);

  useEffect(() => {
    if (data.latestProfile.binusianId != "") {
      if (!isEqual(data.latestProfile.roleId, passportState?.roleId)) {
        enqueueSnackbar("Your role has been updated", {
          variant: "success",
        });
        dispatch(setProfile(data.latestProfile));
      }
      method.onGetRoleMenuAccess(data.latestProfile.roleId);
    }
  }, [data.latestProfile]);

  useEffect(() => {
    if (
      !isEqual(data.roleMenu.access, profileRole?.access) &&
      data.roleMenu.id != ""
    ) {
      enqueueSnackbar("Your menu access has been updated", {
        variant: "success",
      });
      dispatch(setProfileRole(data.roleMenu));
    }
  }, [data.roleMenu]);

  const toggleOpen = passportState ? setSidebarOpen : setMobileBarOpen;
  const isOpen = passportState ? sidebarOpen : mobileBarOpen;

  const navigate = useNavigate();

  return (
    <div className="fixed top-0 z-20 w-full">
      <div className="flex bg-white m-0 px-3 md:px-12 text-primary-main border-solid border-black-1 items-center gap-5 md:justify-between">
        {!passportState && (
          <IconButton
            onClick={() => toggleOpen((prev) => !prev)}
            className={!passportState ? "md:hidden" : ""}
          >
            {isOpen ? (
              <Close className="w-6 h-6 text-primary-main" />
            ) : (
              <Menu className="w-6 h-6 text-primary-main" />
            )}
          </IconButton>
        )}
        <Box className="flex gap-2 justify-between w-full md:w-auto items-center">
          <Box
            component="img"
            className=""
            sx={{
              height: 64,
            }}
            alt="About Us"
            src="/assets/icon/il_ribbon.svg"
          />
          <Box
            component="img"
            sx={{
              height: 40,
              width: 240,
            }}
            alt="About Us"
            src="/assets/icon/il_app_logo.png"
          />
          {passportState && (
            <Box className="md:hidden">
              <AvatarMenu />
            </Box>
          )}
        </Box>
        <div className="hidden md:flex">
          <Stack direction="row" spacing={4} className="items-center">
            {NAV_ITEMS.map((navItem) => (
              <Box
                key={navItem.href}
                className="px-2 py-5 cursor-pointer transition-colors duration-200 ease-in-out hover:bg-gray-100"
                onClick={() => navigate(navItem.href)}
              >
                {navItem.label}
              </Box>
            ))}
            {passportState && <AvatarMenu />}
          </Stack>
        </div>
      </div>
      <div>
        <Collapse
          in={mobileBarOpen}
          timeout="auto"
          unmountOnExit
          className="md:hidden"
        >
          <List component="div" disablePadding className="bg-white">
            {NAV_ITEMS.map((navItem) => (
              <ListItemButton
                component="a"
                href={`${navItem.href}`}
                onClick={() => setMobileBarOpen(false)}
                className="pl-6"
              >
                <ListItemText primary={navItem.label} />
              </ListItemButton>
            ))}
            <ListItem>
              <LoginContent buttonText="Login as Binusian" />
            </ListItem>
          </List>
        </Collapse>
      </div>
    </div>
  );
}
